import React, { Fragment, useState } from 'react';
import { array, object, bool } from 'prop-types';
import styled, { keyframes } from 'styled-components';

import Collapsable from 'library/components/collapsable';
import JourneyCard from 'library/components/journey-card';
import Caret from 'library/icons/caret.svg';
import JourneyLoading from 'components/loading';
import { resolve } from 'library/helpers/path-resolver';

const StyledJourneyCard = styled(JourneyCard)`
  border-top: 10px #f9e4a4 solid;
  display: flex;
  flex-direction: column;
  margin-bottom: 1em;
  padding: .5em;
  overflow: hidden;
  transition: all .2s ease-in-out;
  will-change: height;

  &:hover {
    box-shadow: 0px 6px 9px 4px rgba(0,0,0,0.2)
  }

  .collapsable {
    transition: height .2s ease-in-out;
    will-change: height;
    overflow: hidden;
  }
`;

const StyledResults = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 666px;
  margin: 3em auto .5em;
`;

const RotateAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const StyledLoader = styled.div`
  position: absolute;
  top: 45%;
  width: 100%;
  margin: auto;
  transform: translateY(calc(-50% + .25em));
  color: #ccc;
  > svg {
    animation: ${RotateAnimation} 1s linear infinite;
  }
`;

const StyledCourseResult = styled.div`
  cursor: pointer;
  display: flex;
  padding: .5em;

  svg {
    color: #595959;
    ${props => props.collapsed ? `` : `transform: rotate(180deg)`};
    transition: all .2s ease-in-out;
    margin: .5em;
  }

  > span {
    position: absolute;
    right: 0;
    margin-right: .5em;
  }
`;

const StyledCourseDetails = styled.div`
  display: flex;
  padding: .5em;

  ${props => props.collapsed ? `
    height: 0;
    ` : ``}
`;

const StyledCourseItem = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  span {
    &:first-child {
      color: #207C9D;
      font-size: 13px;
      line-height: 16px;
    }

    color: #595959;
    font-size: 16px;
    line-height: 19px;
  }
`;

const StyledCount = styled.span`
  color: #595959;
  font-size: 16px;
  padding-bottom: .5em;
`;

const CourseResult = ({ course }) => {
  const [collapsed, setCollapsed] = useState(true);

  return (
    <StyledJourneyCard max-width="666px">
      <StyledCourseResult
        onClick={() => setCollapsed(!collapsed)}
        collapsed={collapsed}
      >
        <StyledCourseItem>
          <span>Class Name</span>
          <span>{course.course_name}</span>
        </StyledCourseItem>
        <StyledCourseItem>
          <span>Course Code</span>
          <span>{course.local_course_code}</span>
        </StyledCourseItem>
        <span><Caret/></span>
      </StyledCourseResult>
      <Collapsable collapsed={collapsed} className="collapsable">
        <StyledCourseDetails collapsed={collapsed}>
          <StyledCourseItem>
            <span>School</span>
            <span>{course.school_name}</span>
          </StyledCourseItem>
          <StyledCourseItem>
            <span>District</span>
            <span>{course.district_name}</span>
          </StyledCourseItem>
        </StyledCourseDetails>
      </Collapsable>
    </StyledJourneyCard>
  );
};

CourseResult.propTypes = {
  course: object,
};

const CourseResults = ({ courseData, searching }) => {

  const renderCourse = (course, i) => (
    <CourseResult key={i} course={course['_source']} />
  );

  let count = resolve(courseData, 'total', 0);

  return (
    <Fragment>
      {
        searching
          ? (
            <StyledLoader>
              <JourneyLoading />
            </StyledLoader>
          )
          : null
      }
      {
        count && !searching
          ? (
            <Fragment>
              <StyledResults>
                <StyledCount>{`${count} classes found`}</StyledCount>
                {resolve(courseData, 'hits', []).map(renderCourse)}
              </StyledResults>
            </Fragment>
          )
          : null
      }
    </Fragment>
  );
};

CourseResults.propTypes = {
  courseData: array,
  searching: bool,
};

export default CourseResults;
